import { Control, UseFormRegister, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Textarea } from "~/components/ui/textarea";
import { Label } from "~/components/ui/label";
import { Text } from "~/components/text";
import { SignUpSchemaType } from "~/pages/contact-us/utils";

interface MessageFieldProps {
  register: UseFormRegister<SignUpSchemaType>;
  control: Control<SignUpSchemaType>;
}

export const MessageField = ({ register, control }: MessageFieldProps) => {
  const { t } = useTranslation(["contactUs"]);
  const message = useWatch({ control, name: "message", defaultValue: "" });
  return (
    <div className="space-y-2">
      <Label className="text-sm">{t("contactUs:form.message.label")}</Label>
      <Textarea
        {...register("message", { required: true })}
        placeholder={t("contactUs:form.message.placeholder")}
        className="text-sm resize-none rounded-lg h-32"
        maxLength={2000}
      />
      <Text variant="caption" className="p-0">
        {message.length}/2000
      </Text>
    </div>
  );
};
